'use client';

import React, { ButtonHTMLAttributes } from 'react';
import SmoothScroller from '@/app/components/SmoothScroller';
import { HTMLMotionProps, motion, useAnimation } from 'framer-motion';

interface Props extends HTMLMotionProps<'button'>
{
  target?: string;
  href?: string;
  color?: 'primary' | 'secondary' | 'black';
}

const ButtonContent = ({ children, color = 'black', href = undefined, target = undefined, className = '' }: Props) => {
  return (
    <>
      <div className={ `mt-[6px] md:mt-[13px] row-start-1 row-end-2 -translate-x-[6px] md:-translate-x-[13px] col-start-1 col-end-2 w-full h-full border-3 ${ color === 'primary'
        ? 'border-primary'
        : 'border-black' } rounded-2xl md:rounded-3xl` }>
      </div>
      <motion.div className={ `order-2 z-10 text-center transform  row-start-1 row-end-2 col-start-1 col-end-2 px-8 md:px-12 py-1 md:py-3 rounded-2xl md:rounded-3xl text-button ${ color === 'primary'
        ? 'bg-primary text-white'
        : color ===
        'secondary'
          ? 'bg-secondary'
          : 'bg-black text-white' }
        transition-discrete transition-all group-hover:-translate-x-[3px] group-hover:translate-y-[3px] group-hover:md:-translate-x-[6px] group-hover:md:translate-y-[6px]` }>
        { children }
      </motion.div>
    </>
  );
};

export default function LeviButton({ className = '', children, color, href, rel, target, animate, initial, transition, whileInView, viewport, onClick, ...rest }: Props) {
  const isLink = !!href;
  const sharedClasses = 'grid grid-rows-1 grid-cols-1 group w-max cursor-pointer';
  const controls = useAnimation();

  const handleClick = () => {
    controls.start({
      scale: [1.4, 1],
      transition: {
        duration: 1.3,
        type: 'spring',
        damping: 2,
        stiffness: 100,
      },
    });
  };

  return (
    <motion.div initial={ initial } animate={ animate } transition={ transition } whileInView={ whileInView } viewport={ viewport }>
      <motion.div animate={ controls }>
        { isLink ? (

          <SmoothScroller href={ href }>
            <div className={ `${ sharedClasses } ${ className }` } onClick={ handleClick }>
              <ButtonContent color={ color } className={ '' }>{ children }</ButtonContent>
            </div>
          </SmoothScroller>
        ) : (
          <button className={ `${ sharedClasses } ${ className }` } onClick={ (e) => {
            handleClick();
            if (onClick)
            {
              onClick(e);
            }
          } } { ...rest as ButtonHTMLAttributes<HTMLButtonElement> }>
            <ButtonContent color={ color }>{ children }</ButtonContent>
          </button>
        )
        }
      </motion.div>
    </motion.div>
  );
}
